/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_MineInputs */

const en_tut_sc_mine = /** @type {(inputs: Tut_Sc_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to My issues`)
};

const id_tut_sc_mine = /** @type {(inputs: Tut_Sc_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke Issue saya`)
};

/**
* | output |
* | --- |
* | "Jump to My issues" |
*
* @param {Tut_Sc_MineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_mine = /** @type {((inputs?: Tut_Sc_MineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_MineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_mine(inputs)
	return en_tut_sc_mine(inputs)
});